import React from 'react';
import * as styles from './index.module.scss';
import { motion, useAnimation } from 'framer-motion';

interface HoverLinkItemProps {
  img: string;
  link: string;
  icon: string;
  label: string;
}
const HoverLinkItem = ({ img, link, icon, label }: HoverLinkItemProps) => {
  const controls = useAnimation(); // 创建动画控制器
  const arrowControls = useAnimation(); // 创建动画控制器

  const handleHoverStart = () => {
    controls.start({ scale: 1.7, x: '-20%', y: '20%' }); // 放大到 1.2 倍
    arrowControls.start({ x: '0%', opacity: '1' });
  };

  const handleHoverEnd = () => {
    controls.start({ scale: 1, x: '0%', y: '0%' }); // 恢复原来尺寸
    arrowControls.start({ x: '-100%', opacity: '0' });
  };

  const linkTo = () => {
    link && window.open(link);
  };
  return (
    <motion.div
      onClick={linkTo}
      className={styles.item}
      whileHover={{ backgroundColor: '#316AFF' }}
      onHoverStart={handleHoverStart}
      onHoverEnd={handleHoverEnd}
    >
      <motion.img
        animate={controls}
        transition={{ duration: 0.3 }}
        className={styles.bgIcon}
        src={img}
      />
      <div className={styles.link}>
        <img src={icon} alt="" />
        <span>{label}</span>
        <motion.img
          initial={{ x: '-100%', opacity: '0' }}
          transition={{ duration: 0.3 }}
          animate={arrowControls}
          src="https://cdn-web.mtt.xyz/static/arrow-up-right.png"
        />
      </div>
    </motion.div>
  );
};

export default HoverLinkItem;
